// src/routes/LegacyHostRedirect.jsx
// Sends an old /clubastra/... or /manage/... link to the same page at its
// brand-neutral address, keeping any ?query and #hash.
import { Navigate, useLocation } from 'react-router-dom';
import { toNeutralPath } from './legacyPaths';

export default function LegacyHostRedirect() {
  const { pathname, search, hash } = useLocation();
  const target = toNeutralPath(pathname);
  return <Navigate to={`${target === pathname ? '/' : target}${search}${hash}`} replace />;
}
